import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import Alert from '../Alert/index.js';
import Collapse from '../Collapse/index.js';
import { jsx as _jsx } from "react/jsx-runtime";
function AlertAutoClose(_ref) {
  let {
    bsStyle,
    children,
    className,
    onHide = () => {},
    show = false,
    sticky = true,
    timeout = 4000,
    ...rest
  } = _ref;
  const [showAlert, setShowAlert] = useState(false);
  const handleDismissAlert = () => {
    setShowAlert(false);
  };
  const handleOnHide = () => {
    onHide();
  };
  useEffect(() => {
    if (show) {
      setShowAlert(true);
      setTimeout(handleDismissAlert, timeout);
    }
    return () => {
      clearTimeout(handleDismissAlert);
    };
  }, [show, timeout]);
  return /*#__PURE__*/_jsx(Collapse, {
    className: clsx(className, {
      'sticky-alert container-fluid': sticky
    }),
    in: showAlert,
    timeout: 500,
    onExited: handleOnHide,
    ...rest,
    children: /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(Alert, {
        bsStyle: bsStyle,
        onDismiss: handleDismissAlert,
        children: children
      })
    })
  });
}
export default AlertAutoClose;